import { faCalendarCheck, faCalendarTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import CalendarQuestion from '@/ui/components/CalendarQuestion';
import Tooltip from '@/ui/components/Tooltip';

import type { Props } from './types';

const AppointmentWithinAvailability = ({ appointmentWithinAvailability }: Props) => {
  if (appointmentWithinAvailability === true) {
    return (
      <Tooltip tooltipContent="Appointment is within member's availability">
        <FontAwesomeIcon icon={faCalendarCheck} className="text-green-500" />
      </Tooltip>
    );
  }

  if (appointmentWithinAvailability === false) {
    return (
      <Tooltip tooltipContent="Appointment is outside member's availability">
        <FontAwesomeIcon icon={faCalendarTimes} className="text-amber-500" />
      </Tooltip>
    );
  }

  return (
    <Tooltip tooltipContent="No availability configured for this member, or the appointment existed before setting availability">
      <CalendarQuestion className="text-gray-400" />
    </Tooltip>
  );
};

export default memo(AppointmentWithinAvailability);
